var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.page.contacts) ? _c('div', {
    class: {
      'active': _vm.isActive()
    },
    attrs: {
      "id": _vm.page.contacts.$path
    }
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section__main reduced-width"
  }, [_c('PageTitle', {
    class: {
      'static': _vm.isAnimated
    },
    attrs: {
      "isActive": _vm.isActive(),
      "isAnimated": _vm.isAnimated,
      "titleValue": _vm.page.contacts.title
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contacts",
    class: {
      'static': _vm.isAnimated
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 320 390",
      "width": "320",
      "height": "390",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('polygon', {
    attrs: {
      "points": "0 0, 320 390, 0 390"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cols cols_2"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "cols cols_2"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "contacts__title",
    domProps: {
      "innerHTML": _vm._s(_vm.page.contacts.text_advisor_title)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "contacts__content",
    domProps: {
      "innerHTML": _vm._s(_vm.page.contacts.text_advisor)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cols cols_2"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "contacts__title",
    domProps: {
      "innerHTML": _vm._s(_vm.page.contacts.text_environmental_title)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "contacts__content",
    domProps: {
      "innerHTML": _vm._s(_vm.page.contacts.text_environmental)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "cols cols_2"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "contacts__title",
    domProps: {
      "innerHTML": _vm._s(_vm.page.contacts.text_issues_title)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "contacts__content",
    domProps: {
      "innerHTML": _vm._s(_vm.page.contacts.text_issues)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cols cols_2"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "contacts__title",
    domProps: {
      "innerHTML": _vm._s(_vm.page.contacts.text_press_title)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "contacts__content",
    domProps: {
      "innerHTML": _vm._s(_vm.page.contacts.text_press)
    }
  })])])])])])], 1)])]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a28cbc80","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Contacts.vue
// module id = 206
// module chunks = 0